let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2XMV5")).then(() => parcelRequire('3Sdlj'));